import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import TierServicesSection from '../components/TierServicesSection';
import SolutionsSection from '../components/SolutionsSection';
import IndustrySection from '../components/IndustrySection';
import WhyChooseSection from '../components/WhyChooseSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <TierServicesSection />
      <SolutionsSection />
      <IndustrySection />
      <WhyChooseSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;